import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { publicApi } from "../lib/api";

// Compact live Google rating badge. Renders nothing until a valid rating loads.
export default function GoogleRatingBadge({ className = "", dark = false }) {
  const [data, setData] = useState(null);
  useEffect(() => { publicApi.googleRating().then(setData).catch(() => {}); }, []);

  if (!data || !data.rating) return null;
  const full = Math.round(data.rating);

  const content = (
    <>
      <span className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star key={i} size={14} className={i <= full ? "fill-orange text-orange" : "fill-slate-300 text-slate-300"} />
        ))}
      </span>
      <span className={`text-xs font-semibold ${dark ? "text-slate-200" : "text-slate-600"}`}>
        {data.rating.toFixed(1)} · {data.total} Google reviews
      </span>
    </>
  );

  return data.url ? (
    <a href={data.url} target="_blank" rel="noopener noreferrer" data-testid="google-rating-badge" className={`inline-flex items-center gap-2 hover:opacity-80 transition-opacity ${className}`}>
      {content}
    </a>
  ) : (
    <span data-testid="google-rating-badge" className={`inline-flex items-center gap-2 ${className}`}>{content}</span>
  );
}
